export const TIME_SLOTS: string[] = Array.from({ length: 48 }, (_, index) => {
  const hour = Math.floor(index / 2);
  const minute = (index % 2) * 30;
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
});

export type TimeSlotItem = { value: string; label: string };

export const TIME_SLOT_ITEMS: TimeSlotItem[] = TIME_SLOTS.map((slot) => ({
  value: slot,
  label: slot,
}));

export function isValidTime(digits: string): boolean {
  if (digits.length !== 4) return false;
  const hours = parseInt(digits.slice(0, 2), 10);
  const minutes = parseInt(digits.slice(2), 10);
  return hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
}

/** Whether a "HH:mm" time is allowed given an exclusive lower bound ("HH:mm" strings compare correctly). */
export function isTimeAfter(time: string, afterTime: string | null | undefined): boolean {
  return !afterTime || time > afterTime;
}

export function filterTimeSlotItems(partial: string, afterTime?: string | null): TimeSlotItem[] {
  const allowed = afterTime ? TIME_SLOT_ITEMS.filter(({ value }) => isTimeAfter(value, afterTime)) : TIME_SLOT_ITEMS;
  if (!partial) return allowed;
  const filtered = allowed.filter(({ value }) => value.startsWith(partial));
  return filtered.length > 0 ? filtered : allowed;
}
